<template>
  <b-container>
    <b-form @submit="onSubmit">
      <div v-if="success" class="pt-4">
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </div>
      <div v-else>
        <p v-html="$t('info.removedTaskEvent', [task.Title])"></p>

        <b-button
          class="mt-4 text-center"
          type="submit"
          variant="danger"
          :disabled="disabled"
          >{{ $t("action.confirmed") }}</b-button
        >
      </div>
      
      <div v-if="spinner" class="text-center">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="success"
          label="Spinning"
          disabled="labelStatus"
        ></b-spinner>
      </div>

      <div v-if="error" class="pt-4">
        <b-alert show variant="danger">
          <p>{{ error }}</p>
        </b-alert>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["task", "modalid"],
  data: () => ({
    disabled: false,
    success: false,
    error: "",
    spinner: false,
  }),
  computed: {
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      return urls[process.env.VUE_APP_WHERE].json;
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";

      this.spinner = true;
      this.disabled = true;

      let obj = {
        request: "updateTaskStatus",
        id: this.task.Id,
      };
      
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.$bvModal.hide(this.modalid);
        })
        .catch(() => {
          this.spinner = false;
          this.disabled = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
};
</script>
